import { ScreenSize } from 'ha/modules/UI/constants';
import { defineKey as T } from 'ha/i18n';

export const STATE_NAME = 'cities';

export const ImageHeight = {
  [ScreenSize.XS]: 210,
  [ScreenSize.SM]: 210,
};

export const translation = {
  rentIndex: T('city.nav.rentIndex'),
};
